import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'
import {AddressType, Errors} from "./const";

const Log = new Logger("StoreLocator/Search");

class Search {

  /**
   * Constructor method
   *
   * @param provider: MapProvider reference
   * @param element: optional HTML element which bound events to
   * @param options: optional literal object containing configuration property
   */
  constructor(provider, element){
    this.provider = provider;
    this.$element = $(element);
    this.options = $.extend(true, this.DefaultOptions || {}, provider.options);
    return this;
  }

  /**
   * Search string for autocompleting it
   *
   * @param str: string to be searched
   */
  search(str){
    // temporary code
    return str;
  }

  processOnPlaceChangeResult(placeChangeResult,fallbackObj,clicked){
    Log.error("`processOnPlaceChangeResult` method is not implemented yet");
  }


  /**
   * Store `address`
   *
   * @param str: string to be stored
   */
  store(str){
    Log.error("`store` method is not implemented yet");
  }

}


export default Search
